module.exports = __webpack_public_path__ + "static/media/premiumServicesTransparent.9af8c7c8.png";